<template>
    <div class="cookies">
        <div class="aviso-cookies my-4" :class="showCookies?'activo':''" id="aviso-cookies">
            <div class="row d-flex justify-content-center boxCookies">
                <div class="cerrarCookiesMobile d-flex flex-row-reverse">
                    <a  @click="cerrarCookies" class="cerrarCookies" id="cerrarCookies">X</a>
                </div>
                <div class="col-12 col-lg-7 col-md-7 d-flex flex-column flex-sm-row flex-md-row justify-content-center textosCookies align-items-center align-items-sm-start align-items-md-start">
                    <img class="imgCookies" src="/img-version2/brand/img-cookies.svg">
                    <p class="textoCookies">Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación.  Si cierra este aviso y continúa navegando, consideramos que acepta su uso.  Para más información accede a la <a href="#">Política de cookies</a></p>
                </div>
                <div class="col-12 col-lg-5 col-md-5 d-flex flex-column flex-sm-row flex-md-row justify-content-end align-items-center buttonsCookies">
                    <button class="aceptarCookies d-flex flex-row justify-content-center align-items-center" id="aceptarCookies"
                    @click="cerrarCookies">
                        <img class="imgCookies" src="/img-version2/brand/imgbuttonCookie.svg">
                        Aceptar Cookies
                    </button>
                    <a class="cerrarCookies" id="cerrarCookies-mobile">X</a>
                </div>
            </div>
        </div>
        <div class="fondo-aviso-cookies" :class="showCookies?'activo':''" id="fondo-aviso-cookies"></div>
    </div>
</template>

<script>
export default {
    data (){
        return{
            showCookies: false,
        }
    },
    mounted ( ){
        if(!localStorage.getItem('cookies-aceptadas')){
            this.showCookies = true
        }
    },
    methods:{
        cerrarCookies(){
            localStorage.setItem('cookies-aceptadas', true);
            this.showCookies = false
        },
    },
}
</script>